import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftImgrightContent from "../../Components/internal-pages/Leftimg_rightContent";
import RightimgLeftContent from "../../Components/internal-pages/Rightimg_leftContent";
import ClinetsLogoSlider from "../../Components/home/ClientsLogoSlider";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import NogapRightImage from "../../Components/internal-pages/No_gap_right_Img";
import Pageheader from "../../Components/internal-pages/Page_header";

const Ourwork=()=>{
    const CTAContent = [
        {
          pageHeaderName: "Our Work",
          pageParagraphitalic: "Bringing Your Vision to Life",
          pageParagraphText:
            "Every idea, no matter how big or small, has the potential to transform into something extraordinary. Our team is dedicated to turning your concepts into reality, creating memorable experiences that leave a lasting impression.",
          ContactFormName: "Our-work",
        },
      ];
    
      const ContentImg = [
        {
          index: 0,
          leftImg: "./assests/images/our-work/Group 47.png",
          leftHeading: "Tailored Custom Kits",
          leftSmallpara: "",
          leftParagraph:
            "We specialize in creating beautifully crafted, multi-dimensional custom kits designed to engage and connect with your most valued employees. Whether for corporate gifting, joining kits, or festive gifting, our kits are thoughtfully curated to ensure they make a meaningful impact at every touchpoint. We believe employee gifts should be more than just items – they should be memorable experiences that strengthen relationships.",
          leftRedirectUrl: "/contact-us",
        },
        {
          index: 1,
          leftImg: "./assests/images/our-work/Group 44.png",
          leftHeading: "Apparel with a Purpose  ",
          leftSmallpara: "",
          leftParagraph: 
          "Your company apparel is more than just clothes – they’re a reflection of your culture. We create apparel that not only increases your team’s professional image but also fosters a sense of unity and pride. From design to delivery, we make sure your apparel inspires teamwork and elevates the employee experience, whether as part of joining kits or as a corporate gifting initiative. ",
          leftRedirectUrl: "/contact-us",
        },
      ];
    
      const rightImgContent = [
        {
          index: 0,
          rightImg: "./assests/images/our-work/Branded Merchandise with a Twist.jpg",
          rightHeading: "Branded Merchandise with a Twist ",
          rightSmallpara: "",
          rightParagraph:
            "Think beyond the ordinary – our branded merchandise goes the extra mile in surprising and delighting your employees. We strive to deliver creative, out-of-the-box ideas that not only showcase your brand but also resonate deeply with the people who matter most to you. From employee gifts to joining kits, we make sure that every item reflects your brand’s values and vision.",
          rightRedirectUrl: "/contact-us",
        },
      ];

      const NoGapContent = [
        {
          NogaprightImg: "./assests/images/our-work/Let’s Build Something Special Together.jpg",
          NogaprightHeading: "Let’s Build Something Special Together",
          NogaprightSmallpara: "",
          NogaprightParagraph: "No matter the challenge or opportunity, we’re ready to create the perfect solution for you. Let’s collaborate and bring your vision to life in ways you never thought possible. Whether it's creating the perfect joining kits or festive gifting solutions, we are here to make it happen.",
          NogaprightRedirectUrl: "/contact-us",
        },
      ];
    return(
        <>
           <Helmet>
                <title>eYantra Corporate Gifts in Hyderabad</title>
                <meta name="description" content="Explore eYantra’s work in branded corporate gifting, joining kits, employee rewards, and onboarding kits across Hyderabad with premium welcome gifts."/>
                <meta name="keywords" content="eyantra, our work, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits,corporate gifts in hyderabad, branded corporate"/>
           </Helmet>
           
           <div className="p-0 m-2">
        {/* <Ctapage data={CTAContent} /> */}
        <Pageheader data={CTAContent}/>
        <LeftImgrightContent leftImgContent={ContentImg[0]} />
        <RightimgLeftContent data={rightImgContent[0]} />
        <LeftImgrightContent leftImgContent={ContentImg[1]} />
        <NogapRightImage data={NoGapContent[0]} />


        <div className="my-5">
          <ClinetsLogoSlider />
        </div>
        <Whychooseus />
      </div>
        </>
    )
}

export default Ourwork;